<template lang="pug">
  svg.hot-deal-badge(
    viewBox="0 0 521.63 104.57"
    focusable="false"
    :role="label ? 'img' : undefined"
    :aria-label="label || undefined"
    :aria-hidden="label ? undefined : 'true'"
  )
    rect.bg(width="521.63" height="104.57")
    path.red(d="M159.24,52.78c0,9.33-.09,18.66.05,27.99.04,2.81-.77,4.04-3.68,4.71-19.34,4.44-38.6,4.42-57.93-.05-2.75-.63-3.38-1.84-3.36-4.41.08-19.16.08-38.33,0-57.49-.01-2.56.61-3.78,3.36-4.41,19.33-4.47,38.6-4.49,57.93-.05,2.9.67,3.72,1.89,3.68,4.71-.14,9.66-.05,19.33-.05,28.99ZM115.71,71.91c6.88,0,13.32.11,19.75-.13.88-.03,2.42-1.76,2.43-2.72.17-11.12.17-22.24.01-33.36-.01-1.02-1.43-2.87-2.25-2.9-6.58-.24-13.17-.13-19.95-.13v39.24Z")
    path(d="M238.66,18.26c14.95,0,29.7-.16,44.44.13,3.01.06,6.1,1.58,8.96,2.85,7.53,3.32,12.2,8.06,11.38,17.51-.91,10.58-.01,21.31-.35,31.96-.08,2.48-1.4,5.47-3.14,7.26-5.71,5.85-13.22,8.64-21.15,8.94-13.27.51-26.57.14-40.15.14V18.26ZM259.72,70.57c6.15-.34,11.78-.47,17.37-1.02,3.39-.34,5.13-2.32,5.01-6.12-.24-7.31-.25-14.64,0-21.95.14-3.82-1.71-5.78-4.98-6.19-5.68-.7-11.41-.9-17.4-1.33v36.61Z")
    path.red(d="M83.86,87.06h-20.84c0-7.3-.18-14.41.08-21.49.13-3.69-.97-5.04-4.77-4.85-5.76.28-11.54.07-17.78.07v26.2h-20.92V17.68h20.73v25.02c7.26,0,13.86.12,20.45-.16.78-.03,2.07-2.29,2.1-3.55.21-6.98.1-13.97.1-21.33h20.85v69.4Z")
    path(d="M333.69,34.16v9.49h28.04v16.02h-27.86v10.32h34.98v16.96h-55.11V17.6h55.11v16.56h-35.15Z")
    path(d="M443.09,87.11h-21.44c-1.11-4.25-2.18-8.4-3.29-12.65h-19.96c-.34.41-.66.63-.73.91q-3.23,11.91-15.67,11.91c-2.66,0-5.31,0-8.6,0,3.38-12.03,6.64-23.64,9.91-35.25,2.88-10.25,5.94-20.45,8.57-30.76.84-3.28,2.29-4.15,5.48-4.06,7.66.22,15.33-.03,22.99.17,1.3.03,3.44,1.07,3.73,2.07,6.42,22.36,12.64,44.78,19.02,67.66ZM401.79,58.07h12.84c-2.02-8.36-3.96-16.4-5.91-24.44-.36.06-.71.11-1.07.17-1.93,8-3.86,16-5.86,24.27Z")
    path.red(d="M231.27,34.85h-21.26v52.25h-21.33v-52.07h-21.4v-17.44h63.99v17.26Z")
    path(d="M448.72,17.47h20.63v52.15h32.65v17.37h-53.28V17.47Z")
</template>
<script setup lang="ts">
// Without a label the badge is decorative, for places where the surrounding text already says "Hot Deal"
defineProps<{ label?: string }>()
</script>
<style lang="scss" scoped>
.hot-deal-badge {
  display: block;
  fill: $color-black;

  // Overridable so the badge can blend into non-white surfaces like product tile images
  .bg {
    fill: var(--hot-deal-badge-bg, #{$color-white});
  }

  .red {
    fill: $color-red;
  }
}
</style>
